import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function List() {
    const session = useSelector((state) => { return state.session });

    const profileFilter = chooseProfileFilter();

    const navigate = useNavigate();

    const pathFrontEnd = '/gci/banking-histories/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/banking-histories/delete`,
        endpoint: `${endpointBackend}gci/banking-histories/getall`
    }

    let list = {
        labelTitle: 'Histórico de Transações',
        labelTitleButtonAdd: 'Importar Extrato',
        fieldsShowOnDelete: ['trnamt'],
        showPrintButtons: true,
        canEdit: false,
        canView: false,
        canAdd: false,
        filter: {
            ...profileFilter,
            ...session.banking_history_params
        },
        columns: [
            {
                name: 'bank_account_name',
                label: 'Conta Bancária',
                width: '35%'
            },
            {
                name: 'trnamt',
                label: 'Valor',
                width: '10%'
            },
            {
                name: 'dtposted',
                label: 'Data',
                width: '10%'
            },
            {
                name: 'memo',
                label: 'Descrição',
                width: '35%'
            }
        ],
        buttonsListContainer: [
            {
                name: 'competencies_banking_histories',
                class: 'btn btn-secondary',
                label: 'Voltar',
                tooltipLabel: 'Voltar',
                callback: async () => {
                    navigate(`/gci/banking-histories/competencies`)
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                buttons={list.buttonsListContainer}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
